import { Button } from "@mui/material";
import { ReactComponent as InfoSvg } from "../assets/info.svg";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router";
import { getItem } from "../utils/DataProtection";


export default connect(
    ({
        isAuthUser,
        isValidUser,
        plans
    }) => ({
        isAuthUser,
        isValidUser,
        plans
    }),
    {
        // redux functions
    }
)((props) => {

    let notYetSubscribed = JSON.parse(getItem("notYetSubscribed")) === "true";
    let plans = JSON.parse(getItem("plans"));

    let freeplan = plans && plans.filter((plan,index)=> {return plan.name === "free"});


    const navigate = useNavigate();

    const [daysLeft, setDaysLeft] = useState(getItem("daysLeft") !== null ? getItem("daysLeft") : -1);

    // useEffect(() => {
    //     if (props.isAuthUser && plans?.length && notYetSubscribed === true) {
    //         notYetSubscribed = true
    //     } else {
    //         notYetSubscribed = false
    //     }

    // }, []);


    return (
        <>
            {freeplan !== undefined && freeplan?.length ? <div className="subscription-banner-wrapper" style={{ display: "flex"  }}>
                <div >
                    <div className="textWrapper">
                        <div>
                            <InfoSvg />
                        </div>
                        <div className="text">
                            Ihr Testzugang endet in {daysLeft} Tagen.
                        </div>
                    </div>
                    <div><Button className="button" variant="contained" onClick={() => { navigate("/orderSubscription") }}>Abo abschliessen</Button></div>
                </div>
            </div> : <></>}
        </>)
})